import { useState, useEffect } from 'react';

/**
 * 선택 상태 관리 훅
 * @param {Array} items - 선택 가능한 아이템 배열
 * @param {string} keyField - 고유 키 필드명 (예: 'adAddKakaoFriendId')
 * @returns {Object} { selectedIds, toggleId, selectAll, clearSelection, isSelected }
 */
export function useSelection(items = [], keyField = 'id') {
  const [selectedIds, setSelectedIds] = useState([]);

  // items가 변경되면 선택된 ID 중 유효하지 않은 것들을 제거
  useEffect(() => {
    const validIds = items.map(item => item[keyField]).filter(id => id != null);
    setSelectedIds(prev => prev.filter(id => validIds.includes(id)));
  }, [items, keyField]);

  /**
   * ID 선택/해제 토글
   * @param {any} id - 선택할 ID
   */
  const toggleId = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(selectedId => selectedId !== id) : [...prev, id]
    );
  };

  /**
   * 전체 선택
   */
  const selectAll = () => {
    const allIds = items.map(item => item[keyField]).filter(id => id != null);
    setSelectedIds(allIds);
  };

  /**
   * 선택 초기화
   */
  const clearSelection = () => {
    setSelectedIds([]);
  };

  /**
   * ID 선택 여부 확인
   * @param {any} id - 확인할 ID
   * @returns {boolean}
   */
  const isSelected = (id) => {
    return selectedIds.includes(id);
  };

  return {
    selectedIds,
    toggleId,
    selectAll,
    clearSelection,
    isSelected
  };
}

